<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-overlay :value="isAutoSaving" z-index="9999" opacity="0.8" v-if="AutoSave">
          <div class="text-center d-flex flex-column align-center justify-center">
            <atom-spinner :animation-duration="1500" :size="100" class="mx-auto" color="#038118"/>
            <h3 class="mt-4 green--text">در حال ذخیره سازی خودکار...</h3>
            <p class="green--text mt-2">لطفاً چند لحظه صبر کنید</p>
          </div>
      </v-overlay>

      <v-row class="pa-2" no-gutters>
        <!--    <custom-popup v-model="ready" :cons="{title:'نمونه بیزنس پیج فروشگاهی'}" hide-confirm hide-overlay-->
        <!--                  max-width="900" transition="dialog-bottom-transition">-->
        <!--      <v-card class="p-5" flat>-->
        <!--      </v-card>-->
        <!--    </custom-popup>-->
        <v-col class="pa-2 mb-4 sticky-md" cols="12" md="4" style="top: 12px">
          <v-tabs
            v-model="qrShow"
            background-color="grey lighten-3 pa-1"
            class="rounded-pill mx-auto pa-1"
            color="primary"
            height="48"
            style="width: fit-content"
          >
            <v-tab :disabled="e6 <= 2"> {{ $t("view_qr") }} </v-tab>

            <v-tab> {{ $t("preview") }} </v-tab>
            <v-tab :disabled="e6 <= 1" :ripple="true"> تعرفه‌ها </v-tab>
          </v-tabs>
        </v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker :loading="loading" />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}
              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <view-page v-model="cardTexts" :qr-svg-data-url="qrSvgDataUrl"/>
            </v-tab-item>
            <v-tab-item v-if="!!info?.id && e6>1">
                <Tariffs :id_qr="info.id" :qrtype="'Business'" />
             </v-tab-item>

          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-12">
                  <p>{{ $t("create_qr") }}</p>
                </div>

                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <v-text-field
                    v-model="cardTexts.visitName"
                    :disabled="e6 > 1"
                    append-icon="mdi-pen"
                    class="mt-0 pt-0 contentinfo"
                    clear-icon="mdi-close-circle-outline"
                    clearable
                    dense
                    :label="$t('your_work_page_name')"
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-visitName`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('work_page_name')"
                  />
                </div>
                <div class="col-md-6 mt-0 pt-0 rowinfo">
                  <qr-address-field
                    id="qr-address"
                    ref="address-field"
                    v-model="dtUrl"
                    :disabled="e6 > 1"
                    :error-messages="errors['identifier']"
                    append-icon="mdi-web"
                    class="mt-0 pt-0 contentinfo"
                    dense
                    :hint="$t('qrAddressUpdate.hints.allowedChars')"
                    outlined
                    persistent-hint
                    @updateDest="domainId = $event"
                    :key="$t('qrAddressUpdate.hints.allowedChars')"

                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-dtUrl`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    label="آدرس کیوآر"
                  />
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <next-btn
                :loading="loading"
                style="background: #1b8d39"
                @click="markQr(false)"
              />
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 2" class="px-0 px-md-4" step="2"
              >اطلاعات</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="2">
              <div class="d-flex row mx-2 mt-3 mb-4 justify-start doublebtn">
                <!-- <div class="d-flex row mx-0 mt-2"> -->
                <v-btn
                  :disabled="e6 > 2"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-clearDefaults`"
                  label="حذف اطلاعات پیش‌فرض"
                  :service-name="serviceName"
                  :help-data="helpData"
                />
                <!-- </div> -->
                <!-- <div class="d-flex row mx-0 mt-4"> -->
                <v-btn
                  :loading="agentLoading"
                  class="btn-download ma-0"
                  depressed
                  @click="addAgentData"
                >
                  نمونه داده های نماینده
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-preparedData`"
                  label="نمونه داده‌های نماینده "
                  :service-name="serviceName"
                  :help-data="helpData"
                />
                <!-- </div> -->
              </div>
                <div class="mb-4">
                  <!-- سوییچ و آیکون راهنما -->
                  <div class="d-flex align-center">
                    <v-switch
                      v-model="AutoSave"
                      color="primary"
                      class="mt-0 pt-0 shrink"
                      hide-details
                      label="ذخیره خودکار"
                    ></v-switch>

                    <!-- آیکون راهنما با Tooltip (هاور برای دسکتاپ و تاچ برای موبایل) -->
                    <v-tooltip bottom max-width="320">
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                          icon
                          x-small
                          class="mr-1"
                          v-bind="attrs"
                          v-on="on"
                          @click.stop
                        >
                          <v-icon small color="grey darken-1">
                            mdi-help-circle-outline
                          </v-icon>
                        </v-btn>
                      </template>
                      <span>
                        تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                      </span>
                    </v-tooltip>
                  </div>
                  <div
                    v-if="$vuetify.breakpoint.xsOnly"
                    class="text-caption grey--text text--darken-1 mt-1 pr-1"
                    style="line-height: 1.4"
                  >
                    تغییرات هر بخش با بستن آن بخش به‌صورت خودکار ذخیره می‌شود. (تنظیمات کلی شامل ذخیره خودکار نیستند)
                  </div>
                </div>


              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                :service-name="serviceName"
                :component-name="componentName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="e6 = 3"
                />
              </div>
            </v-stepper-content>

            <v-stepper-step :complete="e6 > 3" class="px-0 px-md-4" step="3"
              >تنظیمات محتوا</v-stepper-step
            >
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="3">
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo2"
                :data="cardTexts"
                :component-name="componentName"
                :service-name="serviceName"
                flat
                @save-required="AutoSave && qrUpdate(false)"
              />

              <div class="row mx-auto">
                <div class="col-md-6">
                  <prev-btn :loading="loading" @click="e6 = 1" />
                </div>

                <div class="col-md-6">
                  <next-btn
                    :loading="loading"
                    style="background: #1b8d39"
                    @click="qrUpdate(true)"
                  />
                </div>
              </div>
            </v-stepper-content>
          </v-stepper>

          <div class="d-none">
            <qr-code-make
              ref="qrCanvas"
              v-model="qrDesign"
              :file.sync="qrSvgDataUrl"
              :link="fullLink"
              @save="qrDesign = $event"
            />
          </div>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-data-show-download-d`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
            />
          </template>
          <v-card class="pa-5">
            <download-file-with-api
              v-if="showDialog"
              :address="`${info?.domain?.name||'qrland.in/'}${info?.identifier}`"
              :visit-name="cardTexts.visitName"
              :qr_id="info?.qrId"

            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import Tariffs from "../../../components/Tariffs/Tariffs.vue";
import { getLanguageCookie } from "../../../../core/plugins/TitleRibbon/utils/languageCookie";
import HelpInfo from "../../qrland/components/helpAcordion/HelpInfo.vue";
import HelpInfoWrapper from "../../qrland/components/helpAcordion/HelpInfoWrapper.vue";
import { Bus, debounce } from "@/main";
import QrAddressField from "@/view/content/fragments/qrAddressField";
import ListExpansion from "@/view/content/fragments/listExpansion";
import NextBtn from "@/view/content/fragments/nextBtn";
import PrevBtn from "@/view/content/fragments/prevBtn";
import QrCustomize from "@/view/pages/qrland/components/qrCustomize";
import QrManagement from "@/view/pages/qrland/components/qrManage/qrManagement";
import ViewPage from "../components/view/viewPage";
import QrMaker from "@/view/pages/qrland/components/qrMaker";
import Counter from "@/view/components/Counter";
import Personnel from "@/view/components/Personnel";
import WorkSheet from "@/view/components/WorkSheet";
import QrCodeMake from "../../qrland/qrCodeStyle/qrCodeMake";
import { mapActions } from "vuex";
import DownloadFileWithApi from "../../qrland/downloadFileWithApi.vue";
import { AtomSpinner } from "epic-spinners";

export default {
  name: "createBpage",

  components: {
    HelpInfo,
    HelpInfoWrapper,
    QrCodeMake,
    DownloadFileWithApi,
    Personnel,
    QrMaker,
    WorkSheet,
    ViewPage,
    QrManagement,
    QrCustomize,
    PrevBtn,
    NextBtn,
    ListExpansion,
    QrAddressField,
    Counter,
    Tariffs,
    AtomSpinner
  },

  data() {
    return {
      AutoSave:false,
      isAutoSaving: false, 
      helpData: [],
      componentName: "Bpage",
      serviceName: "Qrland",
      agentLoading: false,
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdId: null,
      createdDomain: null,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "bannerSelector",
          value: "",
          title: "آپلود بنر",
          subtitle: "",
          icon: "image-area",
          model: "banner",
        },
        {
          name: "Service",
          value: "",
          title: "خدمات",
          subtitle: "",
          icon: "toolbox-outline",
        },
        {
          name: "Faq",
          value: "",
          title: "سوالات متداول",
          subtitle: "",
          icon: "help",
          model: "faq",
        },
        { name: "Blog", value: "", title: "بلاگ", subtitle: "", icon: "text" },
        {
          name: "Product",
          value: "",
          title: "ایجاد محصول",
          subtitle: "",
          icon: "sign-yield",
          model: "Product",
        },
        {
          name: "textCards",
          value: "",
          title: "اطلاعات کاربری",
          subtitle: "",
          icon: "account-outline",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
        },
      ],
      specialInfo2: [
        {
          name: "PicSelector",
          value: "",
          title: "گالری عکس",
          subtitle: "",
          icon: "image-outline",
        },
        {
          name: "VideoGallery",
          value: "",
          title: "گالری ویدئو",
          subtitle: "",
          icon: "video-outline",
        },
        {
          name: "pdfSelector",
          value: "",
          title: "گالری پی دی اف ",
          subtitle: "",
          icon: "file-outline",
        },
        {
          name: "FeedBack",
          value: "",
          title: "بازخورد",
          subtitle: "",
          icon: "reply-outline",
          model: "FeedBack",
        },
        {
          name: "consultationNew",
          value: "",
          title: "فرم درخواست",
          subtitle: "",
          icon: "list-box-outline",
          model: "consultationNew",
        },
        //     {
        //   name: "consultationNew",
        //   value: "",
        //   title: "فرم درخواست",
        //   subtitle: "",
        //   icon: "list-box-outline",
        //   model: "consultationNew",
        // },
        //   {
        //   name: "FeedBack",
        //   value: "",
        //   title: "بازخورد",
        //   subtitle: "",
        //   icon: "reply-outline",
        //   model: "FeedBack",
        // },
        {
          name: "ServiceSection",
          value: "",
          title: "ایجاد بخش",
          subtitle: "",
          icon: "post",
          model: "ServiceSection",
        },
        {
          name: "CounterService",
          value: "",
          title: "موفقیت های بدست آمده",
          subtitle: "",
          icon: "bullseye-arrow",
          model: "CounterService",
        },
        {
          name: "Counter",
          value: "",
          title: "شمارنده معکوس",
          subtitle: "",
          icon: "timer-sand",
          model: "Counter",
        },
        {
          name: "Personnel",
          value: "",
          title: "اعضای تیم",
          subtitle: "",
          icon: "account-multiple-outline",
          model: "Personnel",
        },
        {
          name: "WorkSheet",
          value: "",
          title: "تایم کاری",
          subtitle: "",
          icon: "timetable",
          model: "WorkSheet",
        },
      ],
      dtUrl: null,
      info: null,
      domainId: null,
      cardTexts: {
        pdf: [
          {
            name: "گالری پروپزال‌های کیوآرلند",
            images: [
              {
                title: "پروپزال معرفی محصول",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D8%B2%D8%A7%D9%84%20%DA%A9%DB%8C%D9%88%D8%A2%D8%B1%DA%A9%D8%AF%20%D9%85%D8%B9%D8%B1%D9%81%DB%8C%20%D9%85%D8%AD%D8%B5%D9%88%D9%84.pdf",
                url: "media/productpro.webp",
                description:
                  "معرفی کامل سرویس‌های کیوآرلند، نحوه کار QR کدهای هوشمند، مزایا برای کسب‌وکارها و نمونه کاربردها برای افزایش تعامل مشتریان.",
                selected: true,
              },
              {
                title: "پروپزال کارت ویزیت الکترونیکی",
                link: "https://cdn.terminalads.com/%D9%BE%D8%B1%D9%88%D9%BE%D9%88%D8%B2%D8%A7%D9%84%20%DA%A9%D8%A7%D8%B1%D8%AA%20%D9%88%DB%8C%D8%B2%DB%8C%D8%AA%20%D8%A7%D9%84%DA%A9%D8%AA%D8%B1%D9%88%D9%86%DB%8C%DA%A9%DB%8C.pdf",
                url: "media/cardvisit.webp",
                description:
                  "معرفی کارت ویزیت دیجیتال کیوآرلند، امکانات اشتراک سریع اطلاعات تماس، لینک شبکه‌های اجتماعی و مدیریت حرفه‌ای ارتباط با مشتریان.",
                selected: true,
              },
            ],
          },
        ],
        banner: {
          gallery: [
            {
              name: "",
              images: [
                {
                  name: "6",
                  title: "سامانه بزرگ کیوآر لند",
                  url: "",
                  description: "",
                  link: "qrland.ir",
                  id: 10278,
                },
                {
                  name: "2",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 10279,
                },
              ],
            },
          ],
        },
        Product: {
          title: "محصولات",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        blog: [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: "",
            icon: "",
          },
        ],
        service: [
          {
            title: "پست 1",
            content: "",
            gallery: [{ name: "", images: [] }],
            color: null,
            icon: null,
          },
        ],
        video_gallery: [
          {
            name: "تبلیغاتی",
            images: [
              {
                title: "تریلر کیوآر داینامیک",
                url: "https://www.aparat.com/video/video/embed/videohash/DZUuA/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "کارت ویزیت الکترونیکی",
                url: "https://www.aparat.com/video/video/embed/videohash/NnK26/vt/frame",
                description: "",
                link: "",
              },
            ],
          },
          {
            name: "آموزشی",
            images: [
              {
                title: "ثبت نام در سامانه کیوآر لند",
                url: "https://www.aparat.com/video/video/embed/videohash/UY4KN/vt/frame",
                description: "",
                link: "core.terminalads.com",
              },
              {
                title: "ساخت کارت ویزیت الکترونیکی",
                url: "https://www.aparat.com/video/video/embed/videohash/qoD2r/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "لیست کیوآرهای من",
                url: "https://www.aparat.com/video/video/embed/videohash/xq9rz/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "آمار بازدید کیوآرکدهای داینامیک",
                url: "https://www.aparat.com/video/video/embed/videohash/AyczW/vt/frame",
                description: "",
                link: "",
              },
              {
                title: "آپلودسنتر کیوآرلند",
                url: "https://www.aparat.com/video/video/embed/videohash/FJZ1S/vt/frame",
                description: "",
                link: "",
              },
            ],
          },
        ],
        gallery: [
          {
            name: "کیوآر داینامیک",
            images: [
              {
                name: "18",
                title: "اسکن ساده و آسان",
                url: "",
                description: "",
                link: "",
                id: 12301,
              },
              {
                name: "8",
                title: "یک دنیا اطلاعات را در یک کیوآر جای دهید",
                url: "",
                description: "",
                link: "",
                id: 12302,
              },
              {
                name: "10",
                title: "قابلیت رمز گذاری",
                url: "",
                description: "",
                link: "",
                id: 12304,
              },
              {
                name: "11",
                title: "امکان پرداخت و تسویه",
                url: "",
                description: "",
                link: "",
                id: 12305,
              },
            ],
          },
          {
            name: "کیوآر کد",
            images: [
              {
                name: "12",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 12306,
              },
              {
                name: "2",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 12311,
              },
              {
                name: "6",
                title: "",
                url: "",
                description: "",
                link: "",
                id: 12315,
              },
            ],
          },
        ],
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        consultation: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          items: {
            name: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام",
            },
            surname: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "نام خانوادگی",
            },
            phone: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "شماره موبایل",
            },
            mail: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "ایمیل",
            },
            address: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "آدرس",
            },
            nationalId: {
              is_active: false,
              type: "optional",
              value: "",
              format: "number",
              persian: "کدملی",
              verify: "correct",
            },
            location: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "لوکیشن",
            },
            custom: {
              is_active: false,
              type: "optional",
              value: "",
              format: "select",
              extra: {
                label: "",
                options: [],
              },
            },
            description: {
              is_active: false,
              type: "optional",
              value: "",
              format: "text",
              persian: "توضیحات",
            },
          },
        },
        consultationNew: {
          title: "فرم درخواست",
          description: "",
          sectionColor: { backGround: "", text: "" },
          conform: false,
        },
        Personnel: {
          title: "تیم ما",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        WorkSheet: {
          items: {
            saturday: {
              name: "شنبه",
              shift: [
                {
                  start: "08:00",
                  end: "17:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            sunday: {
              name: "یکشنبه",
              shift: [
                {
                  start: "08:00",
                  end: "17:00",
                },
                {},
              ],
              start: "08:00:00",
              end: "22:00:00",
            },
            monday: {
              name: "دوشنبه",
              shift: [{}, {}],
            },
            tuesday: {
              name: "سه‌شنبه",
              shift: [{}, {}],
            },
            wednesday: {
              name: "چهارشنبه",
              shift: [{}, {}],
            },
            thursday: {
              name: "پنجشنبه",
              shift: [{}, {}],
            },
            friday: {
              name: "جمعه",
              shift: [{}, {}],
            },
          },
        },
        Counter: {
          title: "حالا در آینده زندگی کنید...",
          description: "خبرهای خوبی برایتان داریم.",
          until: "2023-08-23 00:00:00",
          type: "countdown_2",
        },
        visitName: "صفحه کاری کیوآر لند",
        organizationName: "سامانه بزرگ کیوآر لند",
        subOrgan: "مدیریت همزمان ۴۰ روش تبلیغاتی!",
        userName: "خانم خوانساری",
        workField: "پشتیبانی",
        phoneNumber: [
          {
            number: "09999903535",
          },
          {
            number: "02191017077",
          },
          {
            number: "90007425",
          },
        ],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: "02191017077",
        email: "info@qrland.ir",
        fax: "02191016066",
        location:
          "تهران، خیابان شریعتی ، بعد از پل سید خندان\nبن بست خندان ، پلاک 6 ، واحد 3",
        city: "",
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.terminalads.com",
        socialMedia: {
          address: [
            {
              label: "آدرس",
              text: "لینک سایت مورد نظر را وارد نمایید",
              pattern: "",
              prefix: "URL",
              url: "qrland.ir",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
            {
              label: "آدرس",
              text: "لینک سایت مورد نظر را وارد نمایید",
              pattern: "",
              prefix: "URL",
              url: "qr.terminalads.com",
              img: "/media/socialIcon/40icon/location.svg",
              svg: "svgLocation",
            },
          ],
          instagram: [
            {
              label: "اینستاگرام",
              text: "نام کاربری خود را وارد نمایید",
              pattern: "https://instagram.com/",
              prefix: "@",
              url: "terminalads",
              img: "/media/socialIcon/40icon/instagram.svg",
              svg: "svgInstagram",
            },
          ],
          whatsapp: [
            {
              label: "واتساپ",
              text: "+989123456789",
              pattern: "https://wa.me/",
              prefix: "mdi-phone",
              url: "+982191017077",
              img: "/media/socialIcon/40icon/whatsapp.svg",
              svg: "svgWhatsapp",
            },
          ],
          aparat: [
            {
              hint: "نام کانال آپارات خود را وارد نمایید",
              label: "آپارات",
              url: "qrland",
              prefix: "@",
              pattern: "www.aparat.com/",
              img: "/media/socialIcon/40icon/pr/aparat.svg",
              socialText: "",
              svg: "svgAparat",
            },
          ],
        },
        aboutUs:
          "کیوآر چیست؟\nیک نوع بارکد دو بعدی است که می تواند با استفاده از گوشی های هوشمند و دستگاه های اختصاصی کد خوان، خوانده  می شود.\nکیوآرها به طور مستقیم به متن، ایمیل، وب سایت، شماره تلفن و... متصل می شود. \n\nکیوآر داینامیک چیست؟\nکدهای کیو آر داینامیک متصل به سرورهای اختصاصی پیشرفته و هوشمند هستند.\nاینگونه کلیه داده ها و دیتاها را به صورت اتوماتیک در فضای ابری امن و کاملا حفاظت شده، دسته بندی و فشرده سازی  میکند. همین امر باعث رفع کلیه ضعف های کیوآر های استاتیک  می شود.\nکیوآر داینامیک علاوه بر دارا بودن جدیدترین تکنولوژی های دیجیتالی و هوشمند، کاملا انعطاف پذیر است. و می توان با کیوآر داینامیک تمامی شکاف های موجود در یک مجموعه یا سازمان را برطرف نمود.\n برای حفظ محیط زیست، نیاز است استفاده از کاغذ را کاهش داد. ",
        copyright: "تمامی حقوق این سایت متعلق به ترمینال تبلیغات می باشد.",
        center: [51.44663997885132, 35.74305387731438],
        coordinates: [51.446682645747444, 35.743053507096036],
        address:
          "ایران، تهران، شهر تهران، تهران، منطقه ۳ شهر تهران، محله سید خندان، دکتر علی شریعتی، خندان",
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "linear-gradient(to bottom , #007376FF, #08004AFF)",
            text: "#fff",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "#FFFFFF",
            text: "#333333",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        CounterService: {
          title: "دستاوردها",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [
            {
              type: "percent",
              counter: "92",
              name: "کاربران راضی",
              icon: "mdi-account",
              link: "",
            },
            {
              type: "number",
              counter: "180",
              name: "صنف به ما اعتماد کرده اند",
              icon: "mdi-google-classroom",
              link: "",
            },
            {
              type: "number",
              counter: "6",
              name: "خدمت ارائه شده",
              icon: "mdi-qrcode-scan",
              link: "",
            },
            {
              type: "number",
              counter: "64",
              name: "خدمت جدید در راه",
              icon: "mdi-qrcode-plus",
              link: "",
            },
          ],
        },
        ServiceSection: {
          title: "به روز باشید...",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #37A9ADFF, #423890FF)",
            text: "#fff",
          },
          items: [
            {
              section: {
                title: "ثبت نام",
                text: "شما به سرزمین هوشمند دیجیتالی کیوآر لند دعوت شده اید.",
                button: {
                  title: "ثبت نام رایگان",
                  icon: "mdi-ballot-recount",
                  background:
                    "linear-gradient(to right , #1AD0D8FF, #2115A7FF)",
                  color: "#ffffffff",
                  link: "core.terminalads.com",
                  target: "",
                },
                text_position: "left",
                object: {
                  type: "image",
                  url: "",
                },
              },
            },
          ],
        },
        PicSelector: {
          title: null,
          description: null,
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: true,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description:
            "برای آشنایی بیشتر با خدمات هوشمند سامانه کیوآرلند، ویدئو های زیر را مشاهده فرمایید.",
          sectionColor: {
            backGround: "linear-gradient(to right , #25AD96FF, #2039A4FF)",
            text: "#fff",
          },
        },
        Service: {
          title: "خدمات کیوآر لند",
          slider: false,
          description:
            "دیگه وقتشه تکنولوژی دیجیتال را به کسب  وکارتان اضافه کنید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "linear-gradient(to right , #FFFFFFFF, #FFFFFFFF)",
            text: "#fff",
          },
          type: "text",
          items: [
            {
              question: "چقدر از خدمات کیوآرلند راضی بوده اید؟",
              type: "star",
              value: null,
              description: false,
              forceDesc: true,
            },
            {
              question:
                "خدمات کیوآرلند چه میزان از نیازهای شما را پوشش داده است؟",
              type: "star",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question:
                "میزان هزینه پرداختی بابت سرویس دریافتی چقدر معقول بوده است؟",
              type: "star",
              value: null,
              description: false,
              forceDesc: false,
            },
            {
              question: "برای  بهبود خدمات نظر خود را با ما درمیان بگذارید.",
              type: "star",
              value: null,
              description: true,
              forceDesc: true,
            },
          ],
        },
        faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            gallery: [
              {
                name: "گالری عکس",
                images: [],
              },
            ],
          },
          sectionColor: {
            backGround: "linear-gradient(to right , #FF000062, #FF000075)",
            text: "#fff",
          },
          items: [
            {
              question: "1. چطوری می تونم سفارش خودم رو ثبت کنم ؟",
              answer: "کافیست محصولات مورد نظر خود را به سبد خرید اضافه کنید.",
            },
            {
              question: "2. چگونه می توانم در سایت ثبت نام کنم؟",
              answer:
                'کافیست بر روی دکمه "ورود" کلیک کنید و پس از وارد کردن شماره همراه، کد پیامک شده را نیز وارد کنید.',
            },
            {
              question:
                "3. پس از اینکه سفارشم رو ثبت کردم چقدر طول می کشه به دستم برسه؟",
              answer: "در سریع ترین زمان ممکن سفارش شما ارسال خواهد شد.",
            },
            {
              question: "4. هزینه ارسال سفارش چقدر هست؟",
              answer: "هزینه ارسال سفارش نسبت به آدرس شما متغییر خواهد بود.",
            },
            {
              question:
                "5. آیا می تونم بعد از ثبت سفارش، محصولمو تغییر بدم یا کنسل کنم ؟",
              answer: "خیر.\nامکان تغییر یا لغو وجود ندارد.",
            },
          ],
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      qrSvgDataUrl: "",
    };
  },

  watch: {
    "$i18n.locale"(newLocale, oldLocale) {
      if (newLocale !== oldLocale) {
        localStorage.setItem("language", newLocale);
      }
    },
  },
  mounted() {
    const savedLanguage = getLanguageCookie() || "fa";
    this.$i18n.locale = savedLanguage;
    this.cardTexts = {
      ...this.cardTexts,
      ...this.defaultCardData,
    };
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });
  },

  computed: {
    roboatUrl() {
      return this.$roboatUrl || "";
    },
    defaultCardData() {
      const url = this.roboatUrl;

      return {
        banner: {
          gallery: [
            {
              name: "",
              images: [
                {
                  name: "6",
                  title: "سامانه بزرگ کیوآر لند",
                  url: `${url}/upload/6496a552a8435.webp`,
                  link: "qrland.ir",
                  id: 10278,
                },
                {
                  name: "2",
                  title: "",
                  url: `${url}/upload/6496a56fd6188.webp`,
                  id: 10279,
                },
              ],
            },
          ],
        },
        gallery: [
          {
            name: "کیوآر داینامیک",
            images: [
              {
                name: "18",
                title: "اسکن ساده و آسان",
                url: `${url}/upload/64b1534cd75db.webp`,
                id: 12301,
              },
              {
                name: "8",
                title: "یک دنیا اطلاعات را در یک کیوآر جای دهید",
                url: `${url}/upload/64b1535578ce0.webp`,
                id: 12302,
              },
              {
                name: "10",
                title: "قابلیت رمز گذاری",
                url: `${url}/upload/64b1535a61377.webp`,
                id: 12304,
              },
              {
                name: "11",
                title: "امکان پرداخت و تسویه",
                url: `${url}/upload/64b1535a61377.webp`,
                id: 12305,
              },
            ],
          },
          {
            name: "کیوآر کد",
            images: [
              { name: "12", url: `${url}/upload/64b15363d40ee.webp`, id: 12306 },
              { name: "2", url: `${url}/upload/64b15377cda0a.webp`, id: 12311 },
              { name: "6", url: `${url}/upload/64b1538b726e1.webp`, id: 12315 },
            ],
          },
        ],
        ServiceSection: {
          items: [
            {
              section: {
                object: {
                  type: "image",
                  url: `${url}/upload/64b1535578ce0.webp`,
                },
              },
            },
          ],
        },
      };
    },
    fullLink() {
      return this.createdDomain?.replace("/", "") + "/" + this.createdId;
    },
  },

  methods: {
    ...mapActions("localstorage", ["setCreatedQrID"]),
    ...mapActions("local", [
      "updateQrInfo",
      "updateQridentifier",
      "updateQrDomain",
      "updateQrId",
    ]),

    markQr(final = false) {
      if (
        !this.dtUrl ||
        typeof this.$refs["address-field"].dtUrlRule(this.dtUrl) !== "boolean"
      ) {
        this.$toast.clear();
        this.$toast.error("آدرس وارد شده صحیح نمی‌باشد!");
        return;
      }

      this.loading = true;
      let obj = {
        type: "Business",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
        qr: JSON.stringify(this.qrDesign),
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("/v1/testQr/store", obj)
        .then(({ data }) => {
          this.loading = false;
          this.createdId = data.data.identifier;
          this.info = data.data;
          this.createdDomain = this.$refs["address-field"].destItems.find(
            (item) => item.id === this.domainId,
          ).name;
          this.$toast.success("صفحه کاری شما با موفقیت ساخته شد.");
          this.setCreatedQrID(data.data.id);
          this.updateQrInfo(data.data);
          this.updateQridentifier(data.data.identifier);
          this.updateQrDomain(data.data.domain_id);
          this.updateQrId(data.data.id);
          if (this.e6 === 1) {
            this.e6 = 2;
            this.$nextTick(() => {
              setTimeout(() => {
                this.$refs.qrCanvas.appendCanvas(data.data.link);
              }, 500);
              setTimeout(() => {
                this.qrUpdate(false);
              }, 2000);
            });
          }
        })
        .catch((error) => {
          const response = error.response;
          if (response.status === 422)
            this.$modal.error("خطا", response.data.message);

          const errorMap = {
            "The آدرس کیوآر has already been taken.": "errors.qr_address_taken",
          };

          const translatedErrors = {};

          if (response?.data?.errors) {
            const backendErrors = response.data.errors;

            Object.entries(backendErrors).forEach(
              ([fieldKey, fieldMessages]) => {
                try {
                  translatedErrors[fieldKey] = fieldMessages.map((msg) => {
                    const key = errorMap[msg];
                    return key ? this.$t(key) : msg;
                  });

                  const msg = fieldMessages[0];
                  const key = errorMap[msg];
                  this.$toast.error(key ? this.$t(key) : msg, {
                    timeout: 3000,
                  });
                } catch (e) {
                  console.log("Error in mapping translation: ", e);
                }
              },
            );

            this.errors = translatedErrors;
          } else {
            this.$toast.error(this.$t("qr_creation_failed"));
          }

          let el = document.getElementById("qr-address");
          if (el) {
            el.scrollIntoView({ behavior: "smooth", block: "center" });
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    qrUpdate(final = false) {
       if (final || !this.AutoSave) {
        this.loading = true;
      } else {
        this.isAutoSaving = true;
      }
      const data = new FormData();
      data.append("type", "Business");
      data.append("image", this.qrSvgDataUrl);
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");
      data.append("_method", "PUT");
      data.append("qr_id", this.info.qrId);
      data.append("qr", JSON.stringify(this.qrDesign));
      data.append(
        "data",
        JSON.stringify({
          theme: "",
          data: this.cardTexts,
        }),
      );

      this.$api
        .post("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/from-data",
          },
        })
        .then((res) => {
          if (this.e6 === 3 && final) {
            this.qrShow = 0;
            this.goto("qr/list");
          }
          if (final || !this.AutoSave) 
          this.$toast.success("کیوآر صفحه کاری شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
          this.isAutoSaving = false;
        })
        .finally(() => {
          this.loading = false;
          this.isAutoSaving = false;

        });
    },
    clearDefaults() {
      this.cardTexts = {
        banner: {
          gallery: [
            {
              name: "",
              images: [
                {
                  name: "VIP",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 11970,
                },
                {
                  name: "آژانس املاک",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 11976,
                },
                {
                  name: "تابلو سازی",
                  title: "",
                  url: "",
                  description: "",
                  link: "",
                  id: 11995,
                },
              ],
            },
          ],
        },
        Product: {
          title: "محصولات",
          description: "",
          sectionColor: {
            backGround: "linear-gradient(to right , #350808, #1C107CFF)",
            text: "#fff",
          },
          items: [],
        },
        blog: null,
        service: null,
        video_gallery: null,
        gallery: null,
        photoSlider: false,
        gallerySlider: false,
        isGradient: false,
        consultation: {},
        Personnel: {
          personnel: [
            {
              user: {},
            },
          ],
        },
        WorkSheet: {
          work_sheet: {
            saturday: { name: "شنبه", shift: [{}, {}] },
            sunday: { name: "یکشنبه", shift: [{}, {}] },
            monday: { name: "دوشنبه", shift: [{}, {}] },
            tuesday: { name: "سه‌شنبه", shift: [{}, {}] },
            wednesday: { name: "چهارشنبه", shift: [{}, {}] },
            thursday: { name: "پنجشنبه", shift: [{}, {}] },
            friday: { name: "جمعه", shift: [{}, {}] },
          },
        },
        Counter: {
          title: "",
          description: "",
          until: "",
          type: "countdown_2",
        },
        visitName: "صفحه کاری",
        organizationName: "",
        subOrgan: "",
        userName: "",
        workField: "",
        phoneNumber: [{ number: "" }],
        extraFields: [
          {
            icon: "",
            name: "",
            value: "",
          },
        ],
        companyNumber: "",
        email: "",
        fax: "",
        location: "",
        city: "",
        codePostal: "",
        province: "",
        country: "",
        website: "",
        socialMedia: {},
        pdf: {},
        aboutUs: "",
        copyright: "",
        center: [51.44663997885132, 35.74305387731438],
        coordinates: [51.44663997885132, 35.74305387731438],
        address: "",
        pallete: {},
        textCards: {
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        pdfSelector: {
          title: "گالری پی دی اف",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
          layout: "list",
        },
        Blog: {
          title: "بلاگ",
          description: "توضیحات",
          slide: true,
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        // CounterService: {
        //   title: "دستاوردها",
        //   description: "",
        //   sectionColor: {
        //     backGround: "",
        //     text: "",
        //   },
        //   items: [],
        // },
        ServiceSection: {
          title: "بخش جدید",
          description: "",
          sectionColor: {
            backGround: "",
            text: "",
          },
          items: [],
        },
        PicSelector: {
          title: "گالری عکس",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
          slider: false,
        },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "توضیحات",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        faq: {
          title: "سوالات متداول",
          description: "توضیحات",
          design: {
            gallery: [
              {
                name: "گالری عکس",
                images: [],
              },
            ],
          },
          sectionColor: {
            backGround: "linear-gradient(to right , #FF000062, #FF000075)",
            text: "#fff",
          },
          items: [],
        },
        Service: {
          title: "خدمات",
          slider: false,
          description:
            "با استراتژیست بازاریابی دیجیتال ما، شرکت خود را در مسیر درست قرار دهید",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        FeedBack: {
          title: "بازخورد شما",
          description:
            "لطفا با پاسخ گویی به سوالات زیر مارا در خدمات بهتر راهنمایی فرمایید",
          sectionColor: {
            backGround: "",
            text: "",
          },
          type: "",
          items: [],
        },
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      };
    },
    addAgentData() {
      this.agentLoading = true;

      this.$api
        .get("/v1/testQr/find/my.qrland.ir/Agent")
        .then(({ data }) => {
          this.cardTexts = data.data.data.data;
          this.$toast.success("داده ها با موفقیت تغییر یافتند.");
        })
        .catch(({ response }) => {
          this.$toast.error("دریافت داده ها با خطا روبرو شد!");
        })
        .finally(() => (this.agentLoading = false));
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
